import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
import TrainerLayout from '../components/Dashboard/Layout/TrainerLayout.vue'
// GeneralViews
import NotFound from '../components/GeneralViews/NotFoundPage.vue'
// Dashboard pages
const MetricasGenerales = () => import(/* webpackChunkName: "overview" */ '../components/Dashboard/Views/Dashboard/MetricasGenerales/MetricasGenerales.vue')
const Settings__POS = () => import(/* webpackChunkName: "overview" */ '../components/Dashboard/Views/Settings/POS.vue')
const Settings__ProcesosAutomaticos = () => import(/* webpackChunkName: "overview" */ '../components/Dashboard/Views/Settings/ProcesosAutomaticos.vue')
const Settings__Turnos = () => import(/* webpackChunkName: "overview" */ '../components/Dashboard/Views/Plans/Turnos.vue')
const Settings__AccessPoints = () => import(/* webpackChunkName: "settings" */ '../components/Dashboard/Views/Settings/AccessPoints.vue')
const Widgets = () => import(/* webpackChunkName: "overview" */ '../components/Dashboard/Views/Dashboard/Widgets.vue')
// Memberships Pages
const customersMemberships__Memberships = () => import(/* webpackChunkName: "customersMemberships" */ '../components/Dashboard/Views/Customers/Memberships.vue')
const customersMemberships__MMU = () => import(/* webpackChunkName: "customersMemberships" */ '../components/Dashboard/Views/Customers/MembershipsAdm.vue')
const customersMemberships__Customers = () => import(/* webpackChunkName: "customersMemberships" */ '../components/Dashboard/Views/Customers/Customers.vue')
const customersMemberships__SociosV2 = () => import(/* webpackChunkName: "customersMemberships" */ '../components/Dashboard/Views/Customers/Socios.vue')
const customersMemberships__GestionMembresias = () => import(/* webpackChunkName: "customersMemberships" */ '../components/Dashboard/Views/Customers/GestionMembresias.vue')
// Plans Pages
const plans__Viewer = () => import(/* webpackChunkName: "plans" */ '../components/Dashboard/Views/Plans/Plans.vue')
const plans__ShiftsNFamilies = () => import(/* webpackChunkName: "plans" */ '../components/Dashboard/Views/Plans/Shifts&Families.vue')
const plans__Creator = () => import(/* webpackChunkName: "plans" */ '../components/Dashboard/Views/Plans/Creator.vue')

const plans__GestionDePlanes = () => import(/* webpackChunkName: "plans" */ '../components/Dashboard/Views/Plans/GestionDePlanes.vue')
const aiLogin = () => import(/* webpackChunkName: "aiLogin" */ '../components/Dashboard/Views/ai-login/App.vue')
// Personal Trainer Pages
const TrainerDashboard = () => import(/* webpackChunkName: "trainer" */ '../components/Dashboard/Views/Trainer/TrainerDashboard.vue')
const TrainerProfile = () => import(/* webpackChunkName: "trainer" */ '../components/Dashboard/Views/Trainer/TrainerProfile.vue')
const TrainerClients = () => import(/* webpackChunkName: "trainer" */ '../components/Dashboard/Views/Trainer/TrainerClients.vue')
const ExerciseLibrary = () => import(/* webpackChunkName: "trainer" */ '../components/Dashboard/Views/Trainer/ExerciseLibrary.vue')
const WorkoutBuilder = () => import(/* webpackChunkName: "trainer" */ '../components/Dashboard/Views/Trainer/WorkoutBuilder.vue')
const Evaluations = () => import(/* webpackChunkName: "trainer" */ '../components/Dashboard/Views/Trainer/Evaluations.vue')
const ClientProgress = () => import(/* webpackChunkName: "trainer" */ '../components/Dashboard/Views/Trainer/ClientProgress.vue')
const Communication = () => import(/* webpackChunkName: "trainer" */ '../components/Dashboard/Views/Trainer/Communication.vue')
const Schedule = () => import(/* webpackChunkName: "trainer" */ '../components/Dashboard/Views/Trainer/Schedule.vue')
const TrainerSettings = () => import(/* webpackChunkName: "trainer" */ '../components/Dashboard/Views/Trainer/TrainerSettings.vue')
//Sales
const sales_online = () => import(/* webpackChunkName: "aiLogin"*/ '../components/Dashboard/Views/Sales/OnLineSalesDashboard.vue')
const GymSalesDashboard = () => import(/* webpackChunkName: "aiLogin"*/ '../components/Dashboard/Views/Sales/GymSalesDashboard.vue')
const GymSalesCashClosingDashboard = () => import(/* webpackChunkName: "sales"*/ '../components/Dashboard/Views/Sales/GymSalesCashClosingDashboard.vue')
//Herramientas
const MailBuilder = () => import(/* webpackChunkName: "aiLogin"*/ '../components/Dashboard/Views/MailEngine/EmailBuilder.vue')
const ConectoresAPI = () => import(/* webpackChunkName: "tools"*/ '../components/Dashboard/Views/Tools/ConectoresAPI.vue')
const WhatsappWebConector = () => import(/* webpackChunkName: "tools"*/ '../components/Dashboard/Views/Tools/WhatsappWebConector.vue')


// Pages
import User from '../components/Dashboard/Views/Pages/UserProfile.vue'
import TimeLine from '../components/Dashboard/Views/Pages/TimeLinePage.vue'
import Login from '../components/Dashboard/Views/Pages/Login.vue'
import SuccessfullPayment from '../components/Dashboard/Views/Pages/SuccessfullPayment.vue'
import Register from '../components/Dashboard/Views/Pages/Register.vue'
import Lock from '../components/Dashboard/Views/Pages/Lock.vue'
import DailyPassValidator from '../components/Dashboard/Views/Pages/DailyPassValidator.vue'


// Components pages
import Buttons from '../components/Dashboard/Views/Components/Buttons.vue'
import GridSystem from '../components/Dashboard/Views/Components/GridSystem.vue'
import Panels from '../components/Dashboard/Views/Components/Panels.vue'
import SweetAlert from '../components/Dashboard/Views/Components/SweetAlert.vue'
import Notifications from '../components/Dashboard/Views/Components/Notifications.vue'
import Icons from '../components/Dashboard/Views/Components/Icons.vue'
import Typography from '../components/Dashboard/Views/Components/Typography.vue'
import UnderConstruction from '../components/Dashboard/Views/UnderConstruction/underConstruction.vue'

// Forms pages
const RegularForms = () => import(/* webpackChunkName: "forms" */ '../components/Dashboard/Views/Forms/RegularForms.vue')
const ExtendedForms = () => import(/* webpackChunkName: "forms" */ '../components/Dashboard/Views/Forms/ExtendedForms.vue');
const ValidationForms = () => import(/* webpackChunkName: "forms" */ '../components/Dashboard/Views/Forms/ValidationForms.vue')
const Wizard = () => import(/* webpackChunkName: "forms" */ '../components/Dashboard/Views/Forms/Wizard.vue');

// TableList pages
const RegularTables = () => import(/* webpackChunkName: "tables" */ '../components/Dashboard/Views/Tables/RegularTables.vue');
const ExtendedTables = () => import(/* webpackChunkName: "tables" */ '../components/Dashboard/Views/Tables/ExtendedTables.vue');
const PaginatedTables = () => import(/* webpackChunkName: "tables" */ '../components/Dashboard/Views/Tables/PaginatedTables.vue');
// Maps pages
const GoogleMaps = () => import(/* webpackChunkName: "maps" */ '../components/Dashboard/Views/Maps/GoogleMaps.vue')
const FullScreenMap = () => import(/* webpackChunkName: "maps" */ '../components/Dashboard/Views/Maps/FullScreenMap.vue')
const VectorMaps = () => import(/* webpackChunkName: "maps" */ '../components/Dashboard/Views/Maps/VectorMapsPage.vue');

// customers
// import customersMain from '../components/Dashboard/Views/Customers/CustomersMain.vue'

// Calendar
import Calendar from '../components/Dashboard/Views/Calendar/CalendarRoute.vue'
import { path } from 'd3'
// Charts
const Charts = () => import(/* webpackChunkName: "widgets" */ '../components/Dashboard/Views/Charts.vue')

// Downloads
const Downloads = () => import(/* webpackChunkName: "downloads" */ '../components/Dashboard/Views/Downloads/Downloads.vue')

// Sugerencias
const Sugerencias = () => import(/* webpackChunkName: "sugerencias" */ '../components/Dashboard/Views/Sugerencias/Sugerencias.vue')
const SugerenciasPublicas = () => import(/* webpackChunkName: "sugerencias" */ '../components/Dashboard/Views/Sugerencias/SugerenciasPublicas.vue')

// Registros de Acceso (Análisis de Accesos)
const Accesos__Dashboard = () => import(/* webpackChunkName: "sales" */ '../components/Dashboard/Views/Accesos/AccesosDashboard.vue')

// Registro de Cambios (changelog orientado al usuario)
const RegistroDeCambios = () => import(/* webpackChunkName: "overview" */ '../components/Dashboard/Views/Changelog/RegistroDeCambios.vue')

let downloadsMenu = {
  path: '/downloads',
  name: 'Downloads',
  redirect: '/downloads/win',
  component: DashboardLayout,
  children: [
    {
      path: '/downloads/win',
      name: 'downloadsWin',
      component: Downloads
    },
  ],
  meta: { requiresAuth: true, requiresSupport: false }
}

let sugerenciasPage = {
  path: '/sugerencias',
  name: 'Sugerencias',
  component: DashboardLayout,
  redirect: '/sugerencias/gestion',
  children: [
    {
      path: 'gestion',
      name: 'GestionSugerencias',
      component: Sugerencias
    }
  ],
  meta: { requiresAuth: true, requiresSupport: false }
}

let accesosPage = {
  path: '/access',
  name: 'Accesos',
  component: DashboardLayout,
  redirect: '/access/dashboard',
  children: [
    {
      path: 'dashboard',
      name: 'AccesosDashboard',
      component: Accesos__Dashboard
    }
  ],
  meta: { requiresAuth: true, requiresSupport: false }
}

let registroCambiosPage = {
  path: '/registro-cambios',
  name: 'RegistroDeCambios',
  component: DashboardLayout,
  redirect: '/registro-cambios/historial',
  children: [
    {
      path: 'historial',
      name: 'RegistroDeCambiosHistorial',
      component: RegistroDeCambios
    }
  ],
  meta: { requiresAuth: true, requiresSupport: false }
}

let componentsMenu = {
  path: '/components',
  component: DashboardLayout,
  redirect: '/components/buttons',
  children: [
    {
      path: 'buttons',
      name: 'Buttons',
      component: Buttons
    },
    {
      path: 'grid-system',
      name: 'Grid System',
      component: GridSystem
    },
    {
      path: 'panels',
      name: 'Panels',
      component: Panels
    },
    {
      path: 'sweet-alert',
      name: 'Sweet Alert',
      component: SweetAlert
    },
    {
      path: 'notifications',
      name: 'Notifications',
      component: Notifications
    },
    {
      path: 'icons',
      name: 'Icons',
      component: Icons
    },
    {
      path: 'typography',
      name: 'Typography',
      component: Typography
    }

  ],
  meta: { requiresAuth: true, requiresSupport: true }
}
let formsMenu = {
  path: '/forms',
  component: DashboardLayout,
  redirect: '/forms/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Forms',
      component: RegularForms
    },
    {
      path: 'extended',
      name: 'Extended Forms',
      component: ExtendedForms
    },
    {
      path: 'validation',
      name: 'Validation Forms',
      component: ValidationForms
    },
    {
      path: 'wizard',
      name: 'Wizard',
      component: Wizard
    }
  ],
  meta: { requiresAuth: true, requiresSupport: true }
}

let tablesMenu = {
  path: '/table-list',
  component: DashboardLayout,
  redirect: '/table-list/regular',
  children: [
    {
      path: 'regular',
      name: 'Regular Tables',
      component: RegularTables
    },
    {
      path: 'extended',
      name: 'Extended Tables',
      component: ExtendedTables
    },
    {
      path: 'paginated',
      name: 'Paginated Tables',
      component: PaginatedTables
    }],
  meta: { requiresAuth: true, requiresSupport: true }
}

let mapsMenu = {
  path: '/maps',
  component: DashboardLayout,
  redirect: '/maps/google',
  children: [
    {
      path: 'google',
      name: 'Google Maps',
      component: GoogleMaps
    },
    {
      path: 'full-screen',
      name: 'Full Screen Map',
      component: FullScreenMap
    },
    {
      path: 'vector-map',
      name: 'Vector Map',
      component: VectorMaps
    }
  ],
  meta: { requiresAuth: true, requiresSupport: true }
}

let pagesMenu = {
  path: '/pages',
  component: DashboardLayout,
  redirect: '/pages/user',
  children: [
    // {
    //   path: 'user',
    //   name: 'User Page',
    //   component: User
    // },
    {
      path: 'timeline',
      name: 'Timeline Page',
      component: TimeLine
    }
  ],
  meta: { requiresAuth: true, requiresSupport: true }
}

let loginPage = {
  path: '/login',
  name: 'Login',
  component: Login
}
let SuccessfullPaymentPage = {
  path: '/successfull-payment',
  name: 'SuccessfullPayment',
  component: SuccessfullPayment
}
let userProfile = {
  path: '/User',
  name: 'User',
  component: User,
  meta: { requiresAuth: true, requiresSupport: false }
}
let registerPage = {
  path: '/register',
  name: 'Register',
  component: Register
}

let lockPage = {
  path: '/lock',
  name: 'Lock',
  component: Lock
}

let plansPage = {
  path: '/plans',
  component: DashboardLayout,
  redirect: '/plans/overview',
  children: [
    {
      path: 'create',
      name: 'Create',
      component: plans__Creator
      // component: UnderConstruction
    },
    {
      path: 'plansviewer',
      name: 'PlansViewer',
      component: plans__Viewer
      // component: UnderConstruction
    },
    {
      path: 'shifts&families',
      name: 'Shifts&Families',
      component: plans__ShiftsNFamilies
      // component: UnderConstruction
    },

    {
      path: 'biblioteca',
      name: 'Biblioteca de Planes',
      component: plans__GestionDePlanes
    },
    {
      path: 'turnos',
      name: 'Turnos',
      component: Settings__Turnos
    },
  ],
  meta: { requiresAuth: true, requiresSupport: false }
}
let salesPage = {
  path: '/sales',
  component: DashboardLayout,
  redirect: '/sales/online',
  children: [
    {
      path: 'online',
      name: 'SalesMain',
      component: sales_online
    },
    {
      path: 'gym',
      name: 'Ventas en Gimnasio',
      component: GymSalesDashboard
    },
    {
      path: 'cash-closing',
      name: 'Cierres de Caja',
      component: GymSalesCashClosingDashboard
    }
  ],
  meta: { requiresAuth: true, requiresSupport: false }
}
let customersMembershipsPage = {
  path: '/customers&memberships',
  component: DashboardLayout,
  redirect: '/customers&memberships/customers',
  children: [
    {
      path: 'customers',
      name: 'Customers',
      component: customersMemberships__Customers
      // component: process.env.VUE_APP_BUILD_MODE === "2" ? UnderConstruction : customersMemberships__Customers
    },
    {
      path: 'socios-v2',
      name: 'SociosV2',
      component: customersMemberships__SociosV2
    },
    {
      path: 'memberships',
      name: 'MembershipsMain',
      component: customersMemberships__Memberships
    },
    {
      path: 'gestion-membresias',
      name: 'GestionMembresias',
      component: customersMemberships__GestionMembresias
    },
    {
      path: 'MMU',
      name: 'MMU',
      // component: UnderConstruction
      component: customersMemberships__MMU
    },
  ],
  meta: { requiresAuth: true, requiresSupport: false }
}
let herramientasMenu = {
  path: '/tools',
  component: DashboardLayout,
  redirect: '/tools/email-builder',
  children: [
    {
      path: 'email-builder',
      name: 'Email Constructor',
      component: MailBuilder
    },
    {
      path: 'conectores-api',
      name: 'Conectores API',
      component: ConectoresAPI
    },
    {
      path: 'whatsapp-web',
      name: 'WhatsApp Web',
      component: WhatsappWebConector
    }
  ],
  meta: { requiresAuth: true, requiresSupport: false }
}
let settingsPage = {
  path: '/settings',
  component: DashboardLayout,
  redirect: '/settings/POS',
  children: [
    {
      path: 'POS',
      name: 'Points of sales',
      component: Settings__POS
    },
      {
        path: 'AP',
        name: 'AccessPoints',
        component: Settings__AccessPoints
      },
    {
      path: 'ProcesosAutomaticos',
      name: 'ProcesosAutomaticos',
      component: Settings__ProcesosAutomaticos
    },
  ],
  meta: { requiresAuth: true, requiresSupport: false }
}
let aiLoginPage = {
  path: '/ai-login',
  name: 'ai-login',
  component: aiLogin,
}

// Personal Trainer Routes
let trainerRoutes = {
  path: '/trainer',
  component: TrainerLayout,
  redirect: '/trainer/dashboard',
  children: [
    {
      path: 'dashboard',
      name: 'TrainerDashboard',
      component: TrainerDashboard
    },
    {
      path: 'profile',
      name: 'TrainerProfile',
      component: TrainerProfile
    },
    {
      path: 'clients',
      name: 'TrainerClients',
      component: TrainerClients
    },
    {
      path: 'exercises',
      name: 'ExerciseLibrary',
      component: ExerciseLibrary
    },
    {
      path: 'workout-builder',
      name: 'WorkoutBuilder',
      component: WorkoutBuilder
    },
    {
      path: 'evaluations',
      name: 'Evaluations',
      component: Evaluations
    },
    {
      path: 'progress',
      name: 'ClientProgress',
      component: ClientProgress
    },
    {
      path: 'communication',
      name: 'Communication',
      component: Communication
    },
    {
      path: 'schedule',
      name: 'Schedule',
      component: Schedule
    },
    {
      path: 'settings',
      name: 'TrainerSettings',
      component: TrainerSettings
    }
  ],
  meta: { requiresAuth: true, requiresTrainer: true }
}

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'calendar',
        name: 'Calendar',
        component: Calendar
      },
      {
        path: 'charts',
        name: 'Charts',
        component: Charts
      }
    ],
    meta: { requiresAuth: true, requiresSupport: false }
  },
  componentsMenu,
  downloadsMenu,
  sugerenciasPage,
  accesosPage,
  registroCambiosPage,
  plansPage,
  salesPage,
  herramientasMenu,
  settingsPage,
  customersMembershipsPage,
  formsMenu,
  tablesMenu,
  mapsMenu,
  pagesMenu,
  trainerRoutes,
  loginPage,
  registerPage,
  SuccessfullPaymentPage,
  lockPage,
  userProfile,
  {
    path: '/sugerencias-publicas',
    name: 'SugerenciasPublicas',
    component: SugerenciasPublicas,
    meta: { requiresAuth: false }
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/overview',
    children: [
      {
        path: 'overview',
        name: 'Overview',
        component: MetricasGenerales
      },
      {
        path: 'User',
        name: 'User',
        component: User
        // component: UnderConstruction
      },
      {
        path: 'configs',
        name: 'Configuraciones',
        component: UnderConstruction
      },
      {
        path: 'memberships',
        name: 'Socios',
        component: UnderConstruction
      },
      {
        path: 'entries',
        name: 'Accesos',
        component: UnderConstruction
      },
      {
        path: 'sales',
        name: 'Sales',
        component: UnderConstruction
      }
    ],
    meta: { requiresAuth: true, requiresSupport: false }
  },
  aiLoginPage,
  { path: '/dailyPassValidator', component: DailyPassValidator },
  { path: '*', component: NotFound }
];

export default routes
